/* Strap + buckle cart — HEllO EDC

   Two jobs:

   1. Add to Cart posts the strap AND its chosen buckle as two line items,
      linked by a hidden _wc_group property. Shopify's own cart is untouched;
      no Cart Transform, no app, nothing that needs Plus.

   2. In the cart drawer those two lines render as one block: the buckle nests
      under its strap, the pair shows one combined price, and removing or
      re-quantifying the strap does the same to its buckle.

   Runs only when a buckle is actually involved. Every other add-to-cart on the
   site falls through to the theme untouched. */

(function () {
  var cfg = { moneyFormat: '${{amount}}' };
  var busy = false;
  var pending = null;

  try {
    var cfgEl = document.querySelector('[data-wc-cart-cfg]');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) { /* defaults are fine */ }

  /* ---------- helpers ---------- */

  function money(cents) {
    var f = cfg.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    if (f.indexOf('amount_no_decimals') > -1) v = Math.round(cents / 100).toString();
    var sym = (f.match(/^[^{]*/) || [''])[0].replace(/&[^;]+;/g, '').trim();
    return (sym || '$') + v;
  }

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function jsonPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  /* THE blank-drawer fix.

     This theme marks an empty cart with an `is-empty` class on <cart-drawer>
     and on <cart-drawer-items> — not on `.drawer__inner`, which is the only
     place the theme's own renderContents() knows to clear it. So after the
     first add to an empty cart, <cart-drawer> keeps the class it was rendered
     with, the CSS keeps the item list hidden, and the shopper sees an empty
     drawer with a correct total above it. Reloading the page re-renders
     <cart-drawer> without the class, which is why a refresh "fixed" it.

     Every render path calls this so the flag always matches the real cart. */
  function syncEmptyState(res) {
    var empty = !!(res && res.item_count === 0);
    var cd = drawer();
    if (cd) cd.classList.toggle('is-empty', empty);
    document.querySelectorAll('cart-drawer-items').forEach(function (el) {
      el.classList.toggle('is-empty', empty);
    });
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) inner.classList.toggle('is-empty', empty);
  }

  /* True once the returned cart-drawer section HTML actually contains at
     least one product line — a cheap guard against Shopify handing back a
     sections snapshot that hasn't caught up with the write that just
     happened. */
  function sectionHasItems(res) {
    var html = res && res.sections && res.sections['cart-drawer'];
    if (!html) return false;
    try {
      return !!new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-item');
    } catch (e) {
      return false;
    }
  }

  /* Every cart mutation goes through here. It always asks for a fresh
     cart-drawer + cart-icon-bubble render, and if the response looks stale
     (no product rows when the cart isn't actually empty) it retries a couple
     of times with a short backoff rather than painting a blank drawer. */
  function postCartUpdate(updates, attempt) {
    attempt = attempt || 0;
    return jsonPost(route('cart_update_url', '/cart/update') + '.js', {
      updates: updates,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    }).then(function (res) {
      var shouldBeEmpty = res && res.item_count === 0;
      if (shouldBeEmpty || sectionHasItems(res) || attempt >= 2) return res;
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(postCartUpdate(updates, attempt + 1)); }, 180);
      });
    });
  }

  /* The full description of what was chosen — type, colour and finish — read
     from the live panel, so the order and the packing slip say exactly which
     buckle to fit. */
  function buckleLabel(wc) {
    var panel = document.querySelector('[data-wc-panel]');
    var parts = [];
    if (panel) {
      [
        panel.querySelector('[data-wc-pick-type].is-on'),
        panel.querySelector('[data-wc-sw].is-on span'),
        panel.querySelector('[data-wc-pick-finish].is-on')
      ].forEach(function (el) {
        if (el && el.textContent.trim()) parts.push(el.textContent.trim());
      });
    }
    if (!parts.length && wc.componentTitle) parts.push(wc.componentTitle);
    return parts.join(' · ');
  }

  /* Everything the page wants recorded against the strap line.

     This matters more than it looks. Apps that add product options — Easify
     Options, which drives REBEL and FLEXA KEEPERS here — put the shopper's
     choice into `properties[...]` inputs and rely on the theme submitting the
     form normally. We do not submit it; we read the variant id and build our
     own /cart/add.js payload so the buckle can travel as a second line.
     Anything not copied across is silently lost, which is what happened to the
     keeper selection: the shopper chose one, the cart never showed it, and the
     order reached the warehouse with no instruction. */
  function formProperties(form) {
    var out = {};
    var fields = [];

    function collect(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('[name^="properties["]').forEach(function (el) {
        /* Never borrow a field belonging to some other product's form — a
           quick-add modal elsewhere on the page has its own. */
        var owner = el.closest('form[data-type="add-to-cart-form"]');
        if (owner && owner !== form) return;
        if (fields.indexOf(el) < 0) fields.push(el);
      });
    }

    collect(form);

    if (form.id) {
      document.querySelectorAll('[form="' + form.id + '"][name^="properties["]')
        .forEach(function (el) {
          if (fields.indexOf(el) < 0) fields.push(el);
        });
    }

    /* Easify renders its option fields into the product block, and this theme
       then re-positions the keeper drawer as a fixed-position sheet — so those
       inputs do not reliably sit inside the <form> element. Scanning only the
       form found nothing and the keeper choice was still lost. The whole
       product block is the honest scope: an order on the India store shows
       exactly what we are after arriving as ordinary line properties
       ("Install these as my default keepers", "_tpo_add_by", and the keeper
       colours), so they are there to be found. */
    collect(document.querySelector('product-info'));
    collect(document.querySelector('.product__info-wrapper'));
    collect(document.querySelector('.product'));

    fields.forEach(function (el) {
      if (el.disabled) return;

      var type = (el.type || '').toLowerCase();
      if ((type === 'checkbox' || type === 'radio') && !el.checked) return;

      var m = (el.name || '').match(/^properties\[(.*)\]$/);
      if (!m) return;

      var key = m[1];
      var val = el.value == null ? '' : String(el.value).trim();
      if (!key || !val) return;

      /* A property with several selected values (a multi-select, or a set of
         checkboxes sharing one name) reads as one comma-separated line, the
         same way Shopify renders it on the order. */
      out[key] = Object.prototype.hasOwnProperty.call(out, key)
        ? out[key] + ', ' + val
        : val;
    });

    return out;
  }

  /* ---------- add to cart ---------- */

  /* Capture phase: ProductForm binds its own submit handler in its
     constructor, so this has to run before it and stop it outright. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

    var wc = window.WCBuckle;
    if (!wc || !wc.componentVariantId) return;   // not a buckle product — leave it alone

    /* Shopify rejects an entire /cart/add.js if ANY line is unavailable, so an
       out-of-stock buckle would fail the strap too, with an error naming the
       buckle rather than telling them what to do. Stop before that and say so.
       The drawer already refuses to confirm one; this covers the shopper who
       selects it and goes straight for Add to cart. */
    if (wc.componentAvailable === false) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('That buckle is out of stock. Please choose another buckle or clasp before adding to cart.');
      var acc = document.querySelector('#variant-accordion-clasp-type');
      if (acc && acc.scrollIntoView) acc.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || idInput.disabled || !idInput.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    addPair(form, idInput.value, wc);
  }, true);

  function quantityFor(form) {
    var q = form.querySelector('[name="quantity"]');
    if (!q && form.id) q = document.querySelector('[name="quantity"][form="' + form.id + '"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function busyButton(form, on) {
    var pf = form.closest('product-form');
    var btn = pf && pf.querySelector('[type="submit"]');
    if (!btn) return;
    btn.classList.toggle('loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.toggle('hidden', !on);
  }

  function addPair(form, strapVariantId, wc) {
    busyButton(form, true);

    var qty = quantityFor(form);
    var group = 'wc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);

    /* App-supplied options first, ours on top — a keeper choice travels with
       the strap it was chosen for. */
    var strapProps = formProperties(form);
    strapProps._wc_group = group;
    strapProps._wc_role = 'strap';

    var label = buckleLabel(wc);
    if (label) strapProps.Buckle = label;
    if (wc.taper) strapProps._wc_taper = String(wc.taper);

    var items = [
      { id: Number(strapVariantId), quantity: qty, properties: strapProps },
      {
        id: Number(wc.componentVariantId),
        quantity: qty,
        properties: { _wc_group: group, _wc_role: 'buckle' }
      }
    ];

    /* spares are standalone purchases — deliberately not grouped */
    (wc.extras || []).forEach(function (x) {
      if (x && x.id && x.quantity > 0) {
        items.push({
          id: Number(x.id),
          quantity: x.quantity,
          properties: wc.taper
            ? { _wc_role: 'spare', Fits: wc.taper + 'mm taper' }
            : { _wc_role: 'spare' }
        });
      }
    });

    jsonPost(route('cart_add_url', '/cart/add') + '.js', { items: items })
      .then(function (addRes) {
        if (addRes && addRes.status) {
          showError(addRes.description || addRes.message || 'Could not add to cart.');
          return null;
        }
        return postCartUpdate({});
      })
      .then(function (res) {
        if (!res) return;   // add failed, error already shown above
        var cd = drawer();
        if (cd && res.sections) {
          /* Clear the empty-cart flag first, so the drawer isn't painted
             while the CSS is still hiding its own contents. */
          syncEmptyState(res);
          cd.renderContents(res);
          setTimeout(function () {
            syncEmptyState(res);
            paintFromCart(res);
          }, 0);
        } else {
          window.location = route('cart_url', '/cart');
        }
      })
      .catch(function () {
        showError('Could not add to cart.');
      })
      .then(function () {
        busyButton(form, false);
      });
  }

  function showError(msg) {
    var box = document.querySelector('.product-form__error-message-wrapper');
    if (box) {
      var t = box.querySelector('.product-form__error-message');
      if (t) t.textContent = msg;
      box.removeAttribute('hidden');
      return;
    }
    console.warn('[wc-cart] ' + msg);
  }

  /* ---------- cart mutations, keyed not indexed ---------- */

  /* The theme changes lines by index, which shifts the moment a line is
     removed. A pair has to move together, so these go through
     /cart/update.js, which is keyed and atomic. */
  function postUpdate(updates) {
    var wrap = document.querySelector('#CartDrawer .drawer__inner');
    if (wrap) wrap.classList.add('wc-busy');

    return postCartUpdate(updates).then(function (res) {
      applySections(res);
    }).catch(function () {
      if (wrap) wrap.classList.remove('wc-busy');
    });
  }

  function applySections(res) {
    var sections = res && res.sections;
    if (!sections) return;

    if (sections['cart-drawer']) {
      var src = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('.drawer__inner');
      var dst = document.querySelector('#CartDrawer .drawer__inner');
      if (src && dst) {
        dst.innerHTML = src.innerHTML;
        dst.classList.remove('wc-busy');
      }
    }

    if (sections['cart-icon-bubble']) {
      var b = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      var t = document.getElementById('cart-icon-bubble');
      if (b && t) t.innerHTML = b.innerHTML;
    }

    syncEmptyState(res);

    /* res is already a full cart object (same shape as /cart.js) because it
       came back from /cart/update.js — no need to fetch the cart again just
       to paint it. */
    paintFromCart(res);
  }

  /* A grouped strap carries its buckle with it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('cart-remove-button');
    if (!btn) return;
    var row = btn.closest('tr.cart-item');
    if (!row || !row.classList.contains('wc-strap')) return;
    var key = row.getAttribute('data-wc-key');
    var mate = row.getAttribute('data-wc-mate');
    if (!key || !mate) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var updates = {};
    updates[key] = 0;
    updates[mate] = 0;
    postUpdate(updates);
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input.quantity__input');
    if (!input) return;
    var row = input.closest('tr.cart-item');
    if (!row || !row.classList.contains('wc-strap')) return;
    var key = row.getAttribute('data-wc-key');
    var mate = row.getAttribute('data-wc-mate');
    if (!key || !mate) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    var updates = {};
    updates[key] = q;
    updates[mate] = q;      // the buckle always matches its strap
    postUpdate(updates);
  }, true);

  /* ---------- grouped rendering ---------- */

  /* Line keys and properties are not in the drawer's markup — only a 1-based
     index — so the pairing comes from a full cart object, matched on that
     index. Used both when we already have fresh cart JSON in hand (from an
     add/update response) and, as a fallback, after fetching one. */
  function paintFromCart(cart) {
    var rows = document.querySelectorAll('#CartDrawer tr.cart-item');
    if (!rows.length || !cart || !cart.items) return;
    busy = true;
    try { paint(rows, cart); } finally {
      setTimeout(function () { busy = false; }, 0);
    }
  }

  /* Fallback path for renders we didn't trigger ourselves (the theme's own
     re-renders) — nothing fresher is on hand, so ask for the cart directly. */
  function decorate() {
    var rows = document.querySelectorAll('#CartDrawer tr.cart-item');
    if (!rows.length) return;

    fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintFromCart(cart); })
      .catch(function () { busy = false; });
  }

  function rowIndex(row) {
    var holder = row.querySelector('[data-index]');
    var n = holder ? parseInt(holder.getAttribute('data-index'), 10) : NaN;
    if (!isNaN(n)) return n;
    var m = (row.id || '').match(/(\d+)$/);
    return m ? parseInt(m[1], 10) : NaN;
  }

  function paint(rows, cart) {
    var groups = {};
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (!p._wc_group) return;
      var g = groups[p._wc_group] || (groups[p._wc_group] = {});
      g[p._wc_role === 'buckle' ? 'buckle' : 'strap'] = { item: it, index: i + 1 };
    });

    /* DOM rows keyed by their cart-line position, so a buckle row can be
       looked up and moved once we know which strap it belongs to. */
    var rowByIndex = {};
    rows.forEach(function (row) {
      var i = rowIndex(row);
      if (!isNaN(i)) rowByIndex[i] = row;
    });

    rows.forEach(function (row) {
      var idx = rowIndex(row);
      if (isNaN(idx)) return;

      var item = cart.items[idx - 1];
      if (!item) return;
      var props = item.properties || {};
      var g = props._wc_group ? groups[props._wc_group] : null;

      row.classList.remove('wc-strap', 'wc-buckle');
      row.removeAttribute('data-wc-key');
      row.removeAttribute('data-wc-mate');

      /* an orphan (one half removed elsewhere) renders as a normal line */
      if (!g || !g.strap || !g.buckle) return;

      if (props._wc_role === 'buckle') {
        row.classList.add('wc-buckle');
        markFitted(row);
        return;
      }

      row.classList.add('wc-strap');
      row.setAttribute('data-wc-key', g.strap.item.key);
      row.setAttribute('data-wc-mate', g.buckle.item.key);

      /* one price for the pair */
      var total = row.querySelector('.cart-item__totals .price');
      if (total) {
        total.textContent = money(
          g.strap.item.original_line_price + g.buckle.item.original_line_price
        );
      }

      hideStaleClaspOption(row);

      /* Shopify's own cart line order decides where each row lands in the
         drawer, and that order isn't guaranteed to put the strap before its
         buckle. Force it here so the buckle always sits directly beneath its
         strap, never above it. */
      var buckleRow = rowByIndex[g.buckle.index];
      if (buckleRow && buckleRow.previousElementSibling !== row) {
        row.parentNode.insertBefore(buckleRow, row.nextSibling);
      }
    });
  }

  /* The strap variant still carries the old Buckle/Clasp Type option value,
     which no longer determines the buckle. Shown beside the real one it would
     contradict it. */
  function hideStaleClaspOption(row) {
    row.querySelectorAll('.product-option').forEach(function (opt) {
      var dt = opt.querySelector('dt');
      if (!dt) return;
      var label = dt.textContent.replace(/[:\s]+$/, '').trim().toLowerCase();
      if (label === 'buckle/clasp type' || label === 'clasp type') opt.classList.add('wc-hide');
    });
  }

  function markFitted(row) {
    var cell = row.querySelector('.cart-item__details');
    if (!cell || cell.querySelector('.wc-fitted')) return;
    var note = document.createElement('div');
    note.className = 'wc-fitted';
    note.textContent = 'Fitted to the strap above';
    cell.appendChild(note);
  }

  /* ---------- keep it applied ---------- */

  /* The theme re-renders the drawer on its own — quantity changes elsewhere,
     cart page updates, and so on. Re-decorate whenever its contents change,
     ignoring the mutations we cause ourselves. */
  function watch() {
    var host = drawer();
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (busy || pending) return;
      pending = setTimeout(function () { pending = null; decorate(); }, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() {
    watch();
    decorate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
